"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledIconButton = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _IconButtonMixin = require("../../mixins/components/IconButtonMixin");
var StyledIconButton = /*#__PURE__*/_styledComponents.default.button.withConfig({
  displayName: "StyledIconButton",
  componentId: "c11n-8-107-0__sc-lagec-0"
})(["", ""], _IconButtonMixin.IconButtonMixin);
exports.StyledIconButton = StyledIconButton;